const TitleOptions = () => {
  return (
    <div>
      <h1 style={{margin: '0 0 25px 0'}}>👻 Phasmo Buddy</h1>
    </div>
  );
};

export default TitleOptions;
